import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTarget = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 17",
	fill: "none",
	stroke: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99992 15.1666C11.6818 15.1666 14.6666 12.1818 14.6666 8.49992C14.6666 4.81802 11.6818 1.83325 7.99992 1.83325C4.31802 1.83325 1.33325 4.81802 1.33325 8.49992C1.33325 12.1818 4.31802 15.1666 7.99992 15.1666Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6667 8.5H12",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.99992 8.5H1.33325",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 4.49992V1.83325",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 15.1667V12.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTarget;
